import React from "react";
import { TextField } from "@mui/material";

const CustomInput = ({
  placeholder = "Enter text...",
  value,
  setValue,
  required = false,
  width = "100%",
}) => {
  return (
    <TextField
      variant="outlined"
      fullWidth
      placeholder={placeholder}
      value={value}
      onChange={(e) => setValue(e.target.value)}
      required={required}
      InputProps={{
        sx: {
          borderRadius: "12px",
          backgroundColor: "#F9FAFB",
          "& fieldset": {
            borderColor: "#E5E7EB", // subtle gray border
          },
          "&:hover fieldset": {
            // borderColor: "#DA5332", // orange on hover
          },
          "&.Mui-focused fieldset": {
            // borderColor: "#DA5332", // orange when focused
          },
          "&.Mui-focused": {
            boxShadow: "none", // ✅ remove blue focus shadow
            outline: "none", // ✅ remove blue outline
          },
        },
      }}
      sx={{
        width,
        "& .MuiInputBase-input": {
          fontSize: "0.95rem",
          color: "#374151",
          padding: "15px 14px",
        },
        "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
          {
            // borderColor: "#DA5332", // keep orange border
          },
        "& .MuiOutlinedInput-root": {
          "&.Mui-focused": {
            boxShadow: "none", // ✅ ensure no default focus ring
            outline: "none",
          },
        },
      }}
      InputLabelProps={{
        shrink: false,
      }}
    />
  );
};

export default CustomInput;
